import Vue from 'vue'
import Vuex from 'vuex'

import home_moulde from './home/index.js'

Vue.use(Vuex)

const state = {
              
}

const mutations = {

}

const actions = {
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
       Home: home_moulde,
    }
})
